import React, { useState, useEffect } from 'react';
import { Table, Modal } from 'antd';
import { toast, Bounce } from 'react-toastify';
import { Button } from 'components/Button';
import { getUniformSizesApi, createUniformSizeApi, updateUniformSizeApi, deleteUniformSizeApi } from 'api/services/uniformManagement';
import { useUniformMgmt } from '../../context/uniformMgmtContext';
import SizeFormModal from './SizeFormModal';
import DeleteModal from 'components/modelpopup/DeleteModal';
import { itemRender } from 'utils/table';

const SizeList = () => {
  const { fetchSizes } = useUniformMgmt();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const fetchData = () => {
    setLoading(true);
    getUniformSizesApi({}).then(response => {
      setData(response.data?.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (record) => {
    setSelectedSize(record);
    setShowModal(true);
  };

  const handleDelete = () => {
    deleteUniformSizeApi(deleteId).then(() => {
      toast.success('Size deactivated', { position: "top-right", autoClose: 3000, transition: Bounce });
      setDeleteModal(false);
      setDeleteId(null);
      fetchData();
      fetchSizes();
    }).catch(() => {
      toast.error('Failed to delete size', { position: "top-right", autoClose: 3000, transition: Bounce });
    });
  };

  const handleSuccess = () => {
    setShowModal(false);
    setSelectedSize(null);
    fetchData();
    fetchSizes();
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => (
        <span className={`badge ${status ? 'bg-success-light' : 'bg-danger-light'}`}>
          {status ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      title: 'Action',
      render: (_, record) => (
        <div className="d-flex gap-2">
          <Button
            icon="fa fa-pencil"
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleEdit(record)}
          />
          <Button
            icon="fa fa-trash"
            className="btn btn-sm btn-outline-danger"
            onClick={() => { setDeleteId(record.id); setDeleteModal(true); }}
          />
        </div>
      )
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Uniform Sizes</h4>
        <Button
          label="Add Size"
          icon="fa fa-plus"
          className="btn btn-primary btn-sm"
          onClick={() => { setSelectedSize(null); setShowModal(true); }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        loading={loading}
        pagination={{
          total: data.length,
          showSizeChanger: true,
          itemRender
        }}
        scroll={{ x: "max-content" }}
      />

      <SizeFormModal
        open={showModal}
        onClose={() => { setShowModal(false); setSelectedSize(null); }}
        selectedSize={selectedSize}
        onSuccess={handleSuccess}
      />

      <DeleteModal
        Name="Delete Size"
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteHandler={handleDelete}
      />
    </div>
  );
};

export default SizeList;
